import React from "react";
import { SiShopify, SiWoocommerce, SiWix, SiWordpress, SiSquarespace } from "react-icons/si"; // Added new icons
import { MessageSquare, Search, Star } from "lucide-react"; // Added new icons

export default function AddOnServices() {
  return (
    <section className="bg-[#F6F3F1] py-16 px-6">
      <div className="max-w-6xl mx-auto text-center">
        <h2 className="text-5xl  text-gray-900 mb-4">Enhance Your Digital Presence</h2>
        <p className="text-gray-700 max-w-2xl mx-auto mb-12">
          Beyond custom web applications, we offer specialized add-on services to complete your digital ecosystem and drive growth. Choose what you need to elevate your brand.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">

          {/* New Add-on: Foundational Website Design (Wix, WordPress, Squarespace) */}
          <div className="bg-white p-8 text-left shadow-sm border border-gray-200">
            <h3 className="uppercase text-sm text-[#517d74] tracking-widest mb-3">Foundational Web Design</h3>
            <div className="flex items-center gap-3 text-2xl text-gray-700 mb-4">
              <SiWix />
              <SiWordpress />
              <SiSquarespace />
            </div>
            <p className="text-gray-700 mb-6">
              Need a professional online presence without a full custom application? We design stunning, responsive websites on popular platforms like Wix, WordPress, or Squarespace. Perfect for getting started or a quick refresh.
            </p>
            <p className="italic text-gray-600">
              Starts at: <span className="text-2xl  text-gray-900 not-italic ml-2">$1,500</span>
            </p>
          </div>

          {/* Payment Gateway Customization & Advanced E-commerce Features */}
          <div className="bg-white p-8 text-left shadow-sm border border-gray-200">
            <h3 className="uppercase text-sm text-[#517d74] tracking-widest mb-3">Advanced E-Commerce & Payments</h3>
            <div className="flex items-center gap-3 text-2xl text-gray-700 mb-4">
              <SiShopify />
              <SiWoocommerce />
            </div>
            <p className="text-gray-700 mb-6">
              Go beyond basic product listings. This includes custom checkout flows, subscription management setup, advanced inventory synchronization, and complex product configurators tailored to your unique business model.
            </p>
            <p className="italic text-gray-600">
              E-commerce & Payments starts at: <span className="text-2xl  text-gray-900 not-italic ml-2">$2,500</span>
            </p>
          </div>

          {/* Chat Widgets */}
          <div className="bg-white p-8 text-left shadow-sm border border-gray-200">
            <h3 className="uppercase text-sm text-[#517d74] tracking-widest mb-3">Live Chat & Support Widgets</h3>
            <div className="flex items-center gap-3 text-2xl text-gray-700 mb-4">
              <MessageSquare />
            </div>
            <p className="text-gray-700 mb-6">
              Enhance customer service and capture leads in real-time. We'll integrate a responsive live chat widget (e.g., Tidio, Intercom, Crisp) onto your site or app, allowing instant communication with your visitors.
            </p>
            <p className="italic text-gray-600">
              Chat Widget Setup starts at: <span className="text-2xl  text-gray-900 not-italic ml-2">$350</span>
            </p>
          </div>

          {/* SEO Packages */}
          <div className="bg-white p-8 text-left shadow-sm border border-gray-200">
            <h3 className="uppercase text-sm text-[#517d74] tracking-widest mb-3">Advanced SEO Packages</h3>
            <div className="flex items-center gap-3 text-2xl text-gray-700 mb-4">
              <Search />
            </div>
            <p className="text-gray-700 mb-6">
              Boost your organic search rankings and drive targeted traffic. Our SEO packages go beyond foundational optimization to include in-depth keyword research, competitor analysis, content strategy, and ongoing performance monitoring.
            </p>
            <p className="italic text-gray-600">
              SEO Packages start at: <span className="text-2xl  text-gray-900 not-italic ml-2">$800/month</span>
            </p>
          </div>

          {/* Review Funnel */}
          <div className="bg-white p-8 text-left shadow-sm border border-gray-200">
            <h3 className="uppercase text-sm text-[#517d74] tracking-widest mb-3">Smart Review Funnel</h3>
            <div className="flex items-center gap-3 text-2xl text-gray-700 mb-4">
              <Star />
            </div>
            <p className="text-gray-700 mb-6">
              Automate the process of collecting positive reviews. Our smart funnel directs satisfied customers (5-star ratings) to Google or other public review platforms, while privately capturing feedback from those with lower ratings.
            </p>
            <p className="italic text-gray-600">
              Review Funnel Setup starts at: <span className="text-2xl  text-gray-900 not-italic ml-2">$450</span>
            </p>
          </div>

          {/* Re-purposed: Email Marketing Setup */}
          <div className="bg-white p-8 text-left shadow-sm border border-gray-200">
            <h3 className="uppercase text-sm text-[#517d74] tracking-widest mb-3">Email Marketing Set Up</h3>
            <div className="flex items-center gap-3 text-2xl text-gray-700 mb-4">
              {/* No specific icon for email, but you could add one if desired */}
            </div>
            <p className="text-gray-700 mb-4">
              Establish your email marketing presence with a professional setup. This service includes account configuration, custom template design, and seamless integration of signup forms into your website or custom app. Build a robust email list to consistently connect with your audience.
            </p>
            <p className="italic text-gray-600">
              Email Marketing Setup starts at: <span className="text-2xl  text-gray-900 not-italic ml-2">$650</span>
            </p>
          </div>

          {/* Re-purposed: Ongoing Marketing Support - combined with SEO/Content strategy */}
          {/* Removed as dedicated card, SEO package now covers core "ongoing" aspect of traffic generation */}

          {/* Re-purposed: Paid Ad Design Bundle - can be integrated into broader marketing strategy or offered as a separate 'creative' service */}
          {/* Removed as dedicated card to keep focus on web/app-centric add-ons */}

        </div>
      </div>
    </section>
  );
}